export const TOTAL = "Total";
export const CHECKOUT_BREAKDOWN = "Checkout Breakdown";
